import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Toaster } from 'react-hot-toast';
import { store } from './store';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Inventory from './pages/Inventory';
import Procurement from './pages/Procurement';
import Production from './pages/Production';
import ProductionSettings from './pages/ProductionSettings';
import Sales from './pages/Sales';
import Dispatch from './pages/Dispatch';
import VehicleConfig from './pages/VehicleConfig';
import TripManagement from './pages/TripManagement';
import Finance from './pages/Finance';
import HR from './pages/HR';
import Attendance from './pages/Attendance';
import BulkAttendance from './pages/BulkAttendance';
import Shifts from './pages/Shifts';
import AttendanceReports from './pages/AttendanceReports';
import GSTManagement from './pages/GSTManagement';
import PaymentStatus from './pages/PaymentStatus';
import Reports from './pages/Reports';
import Users from './pages/Users';
import ExecutiveDashboard from './pages/ExecutiveDashboard';
import PermissionManager from './pages/PermissionManager';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2E7D32',
    },
    secondary: {
      main: '#FF8F00',
    },
  },
});

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Toaster position="top-right" />
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="procurement" element={<Procurement />} />
              <Route path="production" element={<Production />} />
              <Route path="production-settings" element={<ProductionSettings />} />
              <Route path="sales" element={<Sales />} />
              <Route path="dispatch" element={<Dispatch />} />
              <Route path="vehicle-config" element={<VehicleConfig />} />
              <Route path="trip-management" element={<TripManagement />} />
              <Route path="finance" element={<Finance />} />
              <Route path="hr" element={<HR />} />
              <Route path="attendance" element={<Attendance />} />
              <Route path="bulk-attendance" element={<BulkAttendance />} />
              <Route path="shifts" element={<Shifts />} />
              <Route path="attendance-reports" element={<AttendanceReports />} />
              <Route path="gst" element={<GSTManagement />} />
              <Route path="payment-status" element={<PaymentStatus />} />
              <Route path="reports" element={<Reports />} />
              <Route path="users" element={<Users />} />
<Route path="dashboard" element={<Dashboard />} />
<Route path="executive-dashboard" element={<ExecutiveDashboard />} />
              <Route path="permissions" element={<PermissionManager />} />
            </Route>
          </Routes>
        </Router>
      </ThemeProvider>
    </Provider>
  );
}

export default App;